<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <snackbarcomp v-bind:mesaj="text1" ref="showMessage" v-model="snackbar"></snackbarcomp>
    <loadingcomp v-bind:mesaj="''" v-model="loadingvmodel"></loadingcomp>
    <v-form>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap py-0>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont">{{ $t('Edit-Current-Action') }} &nbsp; {{ekbaslik}}</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Update || guncellebuton" v-if="butongorunum" slot="activator"
                  @click="GuncelleSor()" flat>
                  <span class="hidden-sm-and-down"> {{$t('Edit-Current-Action')}} &nbsp; {{ekbaslik}}
                  </span>
                  <v-icon right dark>add_box</v-icon>
                </v-btn>
                <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Update">{{ $t('Edit-Current-Action') }}</span>
              </v-tooltip>


              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-tooltip bottom>
                    <v-list-tile slot="activator" :disabled="!sayfayetki.Delete" @click.native="cariDelete = true">
                      <v-list-tile-title> {{ $t('Delete') }} </v-list-tile-title>
                    </v-list-tile>
                    <span v-if="!sayfayetki.Delete">{{ $t('Limited-Authorization') }}</span>
                    <span v-if="sayfayetki.Delete"> {{ $t('Delete') }} </span>
                  </v-tooltip>

                  <v-list-tile v-if="Movement.DebitCredit=='A'" @click="makbuzIndirmeSecimAc()">
                  <v-list-tile-title>{{ $t('Print-Collection-Receipt') }}</v-list-tile-title>
                  </v-list-tile>

                  <v-list-tile v-if="Movement.DebitCredit=='B'" @click="makbuzIndirmeSecimAc()">
                  <v-list-tile-title>{{ $t('Print-Payment-Receipt') }}</v-list-tile-title>
                  </v-list-tile>




                  <a target="_self" v-bind:href="'#/carihareketler/index'">
                    <v-list-tile>
                      <v-list-tile-title>{{$t("cancel_button")}}</v-list-tile-title>
                    </v-list-tile>
                  </a>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-layout v-if="carihareketview" row wrap>
            <v-flex pa-1 xs12 sm12 md4>
              <v-card class="white--text">
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>
                    <v-layout justify-space-between column>
                      <v-form ref="formbiletrapor" v-model="valid" lazy-validation>
                        
                        <caricomp :aktifmi="false" v-bind:statecariyedek="caricompitems"
  v-bind:zorunlumu="true" v-model="Movement.Current"></caricomp>

                        <tarihcomp :etiket="$t('Date')" :aktifmi="false" :detaygizle="true" v-model="Movement.MovementDate"
  :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"></tarihcomp>

                        <tarihcomp :etiket="$t('Maturity-Date')" :detaygizle="true" v-model="Movement.MovementDueDate"
                          v-bind:defaultvalue="'ok'"></tarihcomp>
                        <v-autocomplete :items="EvrakTipi1" :rules="[v => !!v || $t('Please-select-v2')]" hide-details=""
                          v-bind="EvrakTipi1" item-text="Title" clearable item-value="Evrakkod"
                          v-model="Movement.DocumentType" :label="$t('Document-Type')"></v-autocomplete>

                        <v-text-field hide-details="" @blur="makbuztipkontrol()" rows="10px" :label="$t('Document-No')"
                          v-model="Movement.DocumentNumber" maxlength="16">
                        </v-text-field>
                        <v-select :items="states1" hide-details="" :label="$t('Debit-Credit')" item-text="text" item-value="id"
                          v-model="Movement.DebitCredit" :rules="[v => !!v || $t('Please-select-v2')]" clearable></v-select>
                      </v-form>
                      <parainput :simge="getparabirimi()" :name="tutar" :error-messages="errors.collect('tutar')"
                        v-model="Movement.Amount" :etiket="etikettutar" data-vv-name="tutar" required
                        v-validate="'required'" :id="tutar" :autocomplete="autocomplete"></parainput>
                      <v-textarea :label="$t('Description')" v-model="Movement.Explanation" maxlength="250" value=""></v-textarea>

                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>

            <v-flex pa-1 xs12 sm12 md4>
              <v-card class="white--text">
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>
                    <v-layout justify-space-between column>

                      <muhasebekoducomp :etiket="$t('Accounting-Code')" v-if="!simpleMode && PB == 'TRY'"  v-model="Movement.ContraAccount"></muhasebekoducomp>

                      <bankakodu  v-model="Movement.BankCode"></bankakodu>

                      <kredikartcomp v-model="Movement.FirmCardNumber"> </kredikartcomp>
                      <v-layout>
                        <v-flex xs12 sm6 md6>
                          <v-autocomplete :items="bankapositems" hide-details="" v-model="Movement.PosCode"
                            @change="taksitgetir(Movement.PosCode)" item-text="Title" item-value="PosKodu" clearable
                            :label="$t('Pos-Code')"></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 md6>
                          <v-select :items="taksitsayi" v-if="PB=='TRY'" hide-details="" v-model="Movement.InstallmentID"
                            item-text="TaksitAciklama" item-value="TaksitID" clearable :label="$t('Instalment')"></v-select>
                        </v-flex>
                      </v-layout>
                      <v-autocomplete v-if="!simpleMode"  :items="masrafmerkezi" hide-details="" :label="$t('Expense-Center-v2')" item-text="Title"
                        clearable v-model="Movement.ExpenseCenter" item-value="Code"></v-autocomplete>
                      <!-- <v-autocomplete hide-details="" :items="Referans" label="Referans" v-model="Movement.Reference"
                        clearable item-text="Title" item-value="Kod"></v-autocomplete> -->
                        <referansmerkezicomp v-if="!simpleMode" :coper="false" :tabdeger="'37'" v-model="Movement.Reference" >
                              </referansmerkezicomp>
                      <v-select hide-details="" :items="makbuztipi" @select="evraktipkontrol()" :label="$t('Receipt-Type')"
                        clearable item-text="text" v-model="Movement.ReceiptType" item-value="value"></v-select>
                      <v-checkbox v-if="!simpleMode && PB == 'TRY'" hide-details v-model="Movement.AccountingIntegration" :label="$t('Integrate-into-Accounting')">
                      </v-checkbox>

                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>

            <v-flex pa-1 xs12 sm12 md4>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12 v-if="!simpleMode">
                  <v-card class="white--text">
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>
                          <v-autocomplete :items="doviztipi" item-text="Title" @change="kurgetir(Movement.ExchangeType)"
                            item-value="DovizKod" hide-details="" v-model="Movement.ExchangeType" :label="$t('Currency-Type')"
                            clearable></v-autocomplete>
                          <dovizinput v-model="Movement.ExchangeRate" :etiket="$t('Foreign-Currency-Exchange-Rate-Amount')"
                            :autocomplete="autocomplete"></dovizinput>
                          <doviztutarcomp :name="doviztutar" v-model="Movement.ExchangeAmount"
                            :etiket="etiketdoviztutar" :id="doviztutar" :autocomplete="autocomplete"></doviztutarcomp>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <v-flex pt-2 xs12 sm12 md12 v-if="!simpleMode && PB == 'TRY' && kdvGoster == true">
                  <v-card class="white--text">
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>

                          <parainput :simge="getparabirimi()" v-model="Movement.GrossAmount" :etiket="$t('Gross')"
                            :autocomplete="autocomplete">
                          </parainput>
                          <parainput :simge="getparabirimi()" v-model="Movement.DiscountAmount" :etiket="$t('Discount')"
                            :autocomplete="autocomplete">
                          </parainput>
                          <v-layout>
                            <v-flex xs12 sm6 md6>
                              <yuzdeinput :etiket="$t('VAT') + ' %'" v-model="Movement.TaxRate" :autocomplete="'autocomplete'">
                              </yuzdeinput>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <parainput :simge="getparabirimi()" v-model="Movement.TaxAmount" :etiket="$t('VAT-Amount')"
                                :autocomplete="autocomplete">
                              </parainput>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
                <v-layout row wrap="">

                  <v-flex xs12 pa-1 sm6 md6>
                    <v-btn color="info" @click="KapatilanFaturaGetir()" block>  {{ $t('Closed-Invoices') }} </v-btn>
                  </v-flex>
                  <v-flex xs12 pa-1 sm6 md6 v-if="PB=='TRY'">
                    <v-btn color="info" @click="karsicariac()" block>  {{ $t('Enter-Counteraction') }} </v-btn>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-flex>


            <v-layout v-if="karsicari" row="" wrap="">
              <v-flex xs12 sm12 md12>


                <v-card flat="" color="#9E9E9E">
                  <v-card-title>
                    <span class="subheading white--text font-weight-medium "> {{ $t('Counteraction-Details') }} </span>
                  </v-card-title>
                </v-card>
              </v-flex>

              <v-flex pa-1 xs12 sm12 md4>
                <v-card class="white--text">
                  <v-card color="grey lighten-5" flat="">
                    <v-card-actions>
                      <v-layout justify-space-between column>

                    <cariaracomp v-bind:etiket="$t('Select-Counter-Current')" v-bind:value="Movement.ContraCurrent" :loading="loading"
                       v-model="Movement.ContraCurrent" :Coper="false"></cariaracomp>


                        <v-autocomplete :items="EvrakTipi2" clearable hide-details=""
                          v-model="Movement.ContraDocumentType" v-bind="EvrakTipi2" item-text="Title"
                          item-value="Evrakkod" :label="$t('Counter-Document-Type')"></v-autocomplete>

                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>

              </v-flex>


              <v-flex pa-1 xs12 sm12 md4>
                <v-card class="white--text">
                  <v-card color="grey lighten-5" flat="">
                    <v-card-actions>
                      <v-layout justify-space-between column>
                        <v-textarea :label="$t('Counter-Explanation')" v-model="Movement.ContraExplanation" value=""></v-textarea>
                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-flex>
              <v-flex pa-1 xs12 sm12 md4>
                <v-card class="white--text">
                  <v-card color="grey lighten-5" flat="">
                    <v-card-actions>
                      <v-layout justify-space-between column>
                        <v-autocomplete hide-details="" @change="kurgetir1(Movement.ContraExchangeType)"
                          :items="doviztipi" item-text="Title" item-value="DovizKod" clearable :label="$t('Counter-Currency-Type')"
                          v-model="Movement.ContraExchangeType"></v-autocomplete>

                        <dovizinput v-model="Movement.ContraExchangeRate" :etiket="$t('Foreign-Currency-Exchange-Rate-Amount')"
                          :autocomplete="autocomplete"></dovizinput>

                        <doviztutarcomp :name="karsidoviztutar" v-model="Movement.ContraExchangeAmount"
                          :etiket="karsietiktutar" :id="karsidoviztutar" :autocomplete="autocomplete"></doviztutarcomp>

                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-flex>

            </v-layout>

          </v-layout>


          <v-layout v-show="faturakapatmaview" row wrap>
            <v-flex xs12 pa-2 sm12 md12>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                  <v-card flat class="white--text">
                    <v-card flat>
                      <v-card-actions>
                        <v-layout row wrap>

                          <v-flex xs12 sm8 md8>
                            <v-layout row wrap>

                              <v-flex xs12 pa-2 sm12 md12>
                                <v-layout align-start="" justify-start="" fill-height="">
                                  <span class="subheading grey--text font-weight-bold">
                                    <v-icon large>account_box</v-icon> {{Title.Kod}} - {{Title.Unvan}}
                                  </span>
                                </v-layout>
                                <v-divider></v-divider>
                              </v-flex>

                              <v-flex xs12 pr-2 pl-2 sm12 md12>
                                <v-layout align-start="" justify-start="" fill-height="">
                                  <span class="subheading grey--text font-weight-bold">
                                    <v-icon large>receipt</v-icon> {{Title.EvrakTip}} - {{Title.EvrakKod}}
                                  </span>
                                </v-layout>
                              </v-flex>

                              <v-flex xs12 sm12 pl-2 md12>
                                <v-layout align-center="" row wrap>
                                  <v-flex xs12 sm3 md3>
                                    <tarihcomp :etiket="$t('Date')" :detaygizle="true" v-model="kapatma.Tarih"
                                      v-bind:defaultvalue="'ok'"></tarihcomp>
                                  </v-flex>
                                  <v-flex xs12 sm4 md2>
                                    <v-layout align-center="" justify-start="" row wrap>
                                      <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false"
                                        ref="fab" @click="filtrele()" color="info" fab dark>
                                        <v-icon>filter_list</v-icon>
                                      </v-btn>
                                      <v-tooltip bottom="" :activator="el" v-model="tooltip">
                                        <span>{{$t('Add-Search-Filter')}}</span>
                                      </v-tooltip>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex xs12 pa-2 sm7 md7>
                                    <v-layout justify-start>
                                      <v-flex xs12 pa-2 sm4 md4>
                                        <v-btn @click="otomatikAta()" block color="info"> {{ $t('Automatic-Search') }}
                                        </v-btn>
                                      </v-flex>
                                      <v-flex xs12 pa-2 sm4 md4>
                                        <v-btn @click="KapatmaKaydet()" block="" color="info">{{$t("save_button")}} </v-btn>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex xs12 pa-2 sm2 md2>
                            <v-card flat color="#1E88E5" class="white--text">
                              <v-layout>
                                <v-flex xs3 sm3 pa-1 md3>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <v-icon color="white" large="">add</v-icon>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm9 md9>
                                  <v-card-title primary-title="">
                                    <v-flex xs12 sm12 md12>
                                      <v-layout>
                                        <v-flex xs12 pa-2 sm12 md12>
                                          <v-list-tile-title>
                                            <v-layout justify-end="">

                                              <span class="headline font-weight-thin">
                                                {{kapatma.Odeme | moneyformat}} {{getparabirimi()}}
                                              </span>
                                            </v-layout>
                                          </v-list-tile-title>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>

                                  </v-card-title>
                                </v-flex>
                              </v-layout>
                              <v-divider light></v-divider>
                              <v-card-actions class="pa-3">
                                <v-layout justify-end="">
                                  <span class="subheading font-weight-">  {{ $t('Collection-Amount') }} </span>
                                </v-layout>
                              </v-card-actions>
                            </v-card>
                          </v-flex>

                          <v-flex xs12 pa-2 sm2 md2>
                            <v-card flat color="#FF5252" class="white--text">
                              <v-layout>
                                <v-flex xs3 sm3 pa-1 md3>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <v-icon color="white" large="">remove</v-icon>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm9 md9>
                                  <v-card-title primary-title="">
                                    <v-flex xs12 sm12 md12>
                                      <v-layout>
                                        <v-flex xs12 pa-2 sm12 md12>
                                          <v-list-tile-title>
                                            <v-layout justify-end="">

                                              <span class="headline font-weight-thin">
                                                {{kapatma.Kalan | moneyformat}} {{getparabirimi()}}
                                              </span>
                                            </v-layout>
                                          </v-list-tile-title>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                  </v-card-title>
                                </v-flex>
                              </v-layout>
                              <v-divider light></v-divider>
                              <v-card-actions class="pa-3">
                                <v-layout justify-end="">

                                  <span class="subheading font-weight-">  {{ $t('Remaining-Amount') }} </span>
                                </v-layout>
                              </v-card-actions>
                            </v-card>
                          </v-flex>



                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 pa-2 sm12 md12>
              <v-card flat class="white--text">
                <v-card flat>
                  <v-card-actions>
                    <v-layout row wrap>
                      <v-flex xs12 pa-2 sm12 md12>
                        <v-layout align-start="" justify-start="" fill-height="">
                          <span class="title grey--text font-weight-">
                            {{ $t('Invoice-Details') }}
                          </span>
                        </v-layout>
                        <v-divider></v-divider>
                      </v-flex>


                      <v-flex xs12 pa-2 sm12>
                        <v-data-table :headers="headerskapatma" :loading="progress" :rows-per-page-items=[50,100]
                          :items="itemskapatma" :search="searchkapatma">
                          <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                          <template slot="items" slot-scope="props">
                            <tr @click="detaygetir(props.item)" item>
                              <v-switch v-model="check[props.item.RecNo]" @change="EkleKaldir(props.item,$event)">
                              </v-switch>
                              <td class="text-xs-left">{{ props.item.FaturaSeri }}</td>
                              <td class="text-xs-left">{{ props.item.Faturano}}</td>
                              <td class="text-xs-left">{{ props.item.OnayFaturaNo }}</td>
                              <td class="text-xs-left">{{ props.item.Tip }}</td>
                              <td class="text-xs-left">{{ props.item.FaturaTarih | dateformat}}</td>
                              <td class="text-xs-right">{{ props.item.Tutar | moneyformat }}</td>
                              <td class="text-xs-right">{{ props.item.Odeme  | moneyformat}}</td>
                              <td class="text-xs-left">{{ props.item.CoperID }}</td>
                              <td class="text-xs-left">{{ props.item.CSirket }}</td>
                            </tr>
                          </template>
                          <v-alert slot="no-results" :value="true" color="error" icon="warning">
                               {{ $t('No-records-searched-for', { value: searchkapatma}) }}
                          </v-alert>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>

            <v-flex xs12 pa-2 sm5 md5>
              <v-card flat class="white--text">
                <v-card flat>
                  <v-card-actions>
                    <v-layout row wrap>
                      <v-flex xs12 pt-2 sm12 md12>
                        <v-layout align-start="" justify-start="" fill-height="">
                          <span class="title info--text font-weight-">
                            {{ $t('Invoice-Information') }}
                          </span>
                        </v-layout>
                        <v-divider></v-divider>
                      </v-flex>

                      <v-flex xs12 sm12>

                        <v-data-table :headers="headerskapatmadetay" no-action :items="itemskapatmadetay"
                          :search="searchkapatmadetay">
                          <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                          <template slot="items" slot-scope="props">
                            <tr @click="git(props.item)" item>
                              <td class="text-xs-left">{{ props.item.FaturaSeri }}</td>
                              <td class="text-xs-left">{{ props.item.Faturano }}</td>
                              <td class="text-xs-left">{{ props.item.Aciklama}}</td>
                              <td class="text-xs-right">{{ props.item.Tutar | moneyformat }}</td>

                            </tr>
                          </template>
                          <v-alert slot="no-results" :value="true" color="error" icon="warning">
                             {{ $t('No-records-searched-for', { value: searchkapatma}) }}
                          </v-alert>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>

            <v-flex xs12 pa-2 sm7 md7>
              <v-card flat class="white--text">
                <v-card flat>
                  <v-card-actions>
                    <v-layout row wrap>
                      <v-flex xs12 pt-2 sm12 md12>
                        <v-layout align-start="" justify-start="" fill-height="">
                          <span class="title red--text font-weight-">
                            {{ $t('Collection-Details-Approval') }}
                          </span>
                        </v-layout>
                        <v-divider></v-divider>
                      </v-flex>

                      <v-flex xs12 sm12>

                        <v-data-table :headers="headerskapatmaodeme" no-action :items="itemskapatmaodeme"
                          :search="searchkapatma">
                          <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                          <template slot="items" slot-scope="props">
                            <tr item>

                              <td class="text-xs-left">{{ props.item.FaturaSeri }}</td>
                              <td class="text-xs-left">{{ props.item.FaturaNo}}</td>
                              <td class="text-xs-left">{{ props.item.Aciklama }}</td>
                              <td class="text-xs-left">{{ props.item.Tip }}</td>
                              <td class="text-xs-left">{{ props.item.Tutar | moneyformat}}</td>
                              <td class="text-xs-left">{{ props.item.FaturaID }}</td>
                              <td class="text-xs-left">{{ props.item.BiletID }}</td>
                              <td class="text-xs-right">{{ props.item.BiletHYID  }}</td>
                              <td class="text-xs-right">{{ props.item.OdemeKod }}</td>
                              <td class="text-xs-right">{{ props.item.SiraNo}}</td>
                              <td class="text-xs-left">{{ props.item.CKart }}</td>
                              <td class="text-xs-left">{{ props.item.CoperID }}</td>
                              <td class="text-xs-left">{{ props.item.CoperSirket }}</td>
                              <td class="text-xs-left">{{ props.item.RecordNo }}</td>

                            </tr>
                          </template>
                          <v-alert slot="no-results" :value="true" color="error" icon="warning">
                            {{ $t('No-records-searched-for', { value: searchkapatma}) }}
                          </v-alert>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>



            <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="450px">
              <v-card>
                <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
                <v-divider></v-divider>
                <v-card-text>

                  <v-flex pa-1 xs12 sm12 md12>
                    <v-card flat>
                      <v-card flat="">
                        <v-card-actions>
                          <v-layout row="" wrap="">
                            <v-flex xs12 sm6 md6>
                              <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="true"
                                v-model="FaturaKapatma.Filtreler.Tarih1"></tarihcomp>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="true"
                                v-model="FaturaKapatma.Filtreler.Tarih2">
                              </tarihcomp>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field mask="############" hide-details=""
                                v-model="FaturaKapatma.Filtreler.BaslangicFatNo" :label="$t('Invoice-No')"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field mask="############" v-model="FaturaKapatma.Filtreler.BitisFatNo"
                                hide-details="" :label="$t('Invoice-No')"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <parainput :simge="getparabirimi()" v-model="FaturaKapatma.Filtreler.TutarMin"
                                :etiket="$t('Remaining')" :autocomplete="autocomplete">
                              </parainput>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <parainput :simge="getparabirimi()" v-model="FaturaKapatma.Filtreler.TutarMax"
                                :etiket="$t('Remaining')" :autocomplete="autocomplete">
                              </parainput>
                            </v-flex>
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>

                  <v-flex xs12 pl-1 pr-1 pt-2 sm12 md12>
                    <v-layout align-start="" justify-start="" fill-height="">
                      <span class="subheading grey--text font-weight-">
                        {{ $t('Options-v2') }}
                      </span>
                    </v-layout>
                    <v-divider></v-divider>
                  </v-flex>

                  <v-layout row pa-1 wrap>

                    <v-flex xs12 sm6 md6>
                      <v-radio-group v-model="FaturaKapatma.Filtreler.Fatsec" :label="$t('Invoice-Type-v2')">
                        <v-radio :label="$t('All')" value="H"></v-radio>
                        <v-radio :label="$t('Ticket')" value="B"></v-radio>
                        <v-radio :label="$t('Free')" value="S"></v-radio>
                        <v-radio label="Coper" value="C"></v-radio>
                      </v-radio-group>
                    </v-flex>

                    <v-flex xs12 sm6 md6>
                      <v-radio-group v-model="FaturaKapatma.Filtreler.TarihTip" label="Tarih Tip">
                        <v-radio :label="$t('Invoice-Date')" value="T"></v-radio>
                        <v-radio :label="$t('Maturity-Date')" value="V"></v-radio>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" flat @click="kapatmafiltreiptal()">{{ $t('cancel_button') }}</v-btn>
                  <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialogKapatilanFatura" scrollable="" max-width="550px">
              <v-card color="grey lighten-4">
                <v-card-title> {{ $t('Closed-Invoices') }} </v-card-title>
                <v-divider></v-divider>
                <v-card-text>

                  <v-flex xs12 sm12 md12>
                    <v-layout row="" wrap="">
                      <v-flex v-if="FaturaDevam" xs12 sm12 md12>
                        <v-alert :value="true" type="error">
                          {{ $t('closed-invoices-payment-Do-you-wish-continue') }}
                        </v-alert>
                      </v-flex>

                      <v-flex xs12 sm12 md12>
                        <v-data-table hide-actions :headers="headerskapatilanfatura" no-action
                          :items="itemskapatilanfatura">
                          <template slot="items" slot-scope="props">
                            <tr item>
                              <td class="text-xs-left">{{ props.item.FaturaNo }}</td>
                              <td class="text-xs-left">{{ props.item.Tip}}</td>
                              <td class="text-xs-left">{{ props.item.Tarih | dateformat }}</td>
                              <td class="text-xs-left">{{ props.item.BiletPnrNo }}</td>
                              <td class="text-xs-left">{{ props.item.Tutar | moneyformat}}</td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn v-if="!FaturaDevam" color="blue darken-1" flat @click.native="dialogKapatilanFatura=false">
                    {{ $t('OK') }}</v-btn>
                  <v-btn v-if="FaturaDevam" color="blue darken-1" flat @click.native="dialogKapatilanFatura=false">{{$t("cancel_button")}}
                  </v-btn>
                  <v-btn v-if="FaturaDevam" color="blue darken-1" flat @click="carihareketGuncelle()">
                    {{ $t('Complete-Process') }}
                  </v-btn>

                </v-card-actions>
              </v-card>
            </v-dialog>

          </v-layout>


        </v-layout>
      </v-card>
    </v-form>

<v-layout row justify-center>
  <v-dialog v-model="cariDelete" persistent max-width="290">
    <v-card>
      <v-card-title class="headline">Cari Sil</v-card-title>
      <v-card-text>        
         {{ $t('Are-you-sure-want-delete') }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="carihareketSil()"> {{ $t('Delete') }} </v-btn>
        <v-btn color="primary" flat @click.native="cariDelete = false">{{ $t('cancel_button') }} </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-layout>

<v-layout row justify-center>
  <v-dialog v-model="receiptDownloadDialog" max-width="420">
    <v-card>
      <v-card-title class="headline">
        Makbuz İndirme Formatı
      </v-card-title>

      <v-card-text>
        Makbuzu hangi formatta indirmek istiyorsunuz?
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn flat color="blue darken-1" @click="receiptDownloadDialog = false">
          {{ $t('cancel_button') }}
        </v-btn>

        <v-btn flat color="blue darken-1" @click="tahsilatMakbuz('HTML')">
          HTML
        </v-btn>

        <v-btn color="info" @click="tahsilatMakbuz('PDF')">
          PDF
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-layout>


  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import tarihcomp from '../customcomp/tarihim'
  import yuzdeinput from '../customcomp/yuzdeinput'
  import parainput from '../customcomp/parainput'
  import dovizinput from '@/components/app/customcomp/dovizinput.vue'
  import doviztutarcomp from '@/components/app/customcomp/doviztutarcomp.vue'
  import kredikartcomp from "@/components/app/bilet/partpage/kredikartcomp.vue"
  import caricomp from '@/components/app/customcomp/caricomp.vue'
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import loadingcomp from "@/components/app/customcomp/loadingcomp"
  import muhasebekoducomp from '@/components/app/customcomp/muhasebekoducomp.vue'
  import cariaracomp from '@/components/app/customcomp/cariaracomp'
  import bankakodu from '@/components/app/customcomp/bankakodu'
  import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue";
  export default {

    props: {
      carikod: ''
    },


    data() {
      return {
        simpleMode: false,
        kdvGoster:false,
        PB:'TRY',
        butongorunum: true,
        cariDelete:false,
        receiptDownloadDialog: false,
        guncellebuton: false,
        loadingvmodel: null,
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        FaturaDevam: false,
        dialogKapatilanFatura: false,
        caricompitems: [],
        check: [],
        islemdurum: true,
        ekbaslik: null,
        brutgirilentoplam: 0,
        tutardisabled: true,
        tooltip: false,
        el: null,
        dialogfiltre: false,
        kapatma: {
          Tarih: null,
          Odeme: 0,
          Kalan: 0,
          OdemeKod: null,
        },
        Title: {
          Kod: null,
          Unvan: null,
          EvrakTip: null,
          EvrakKod: null,
        },
        itemskapatilanfatura: [],
        headerskapatilanfatura: [{
            text: this.$t('Invoice-No'),
            value: 'FaturaNo',
            sortable: false
          },
          {
            text: this.$t('Type'),
            value: 'Tip',
            sortable: false
          },
          {
            text: this.$t('Date'),
            value: 'Tarih',
            sortable: false

          },
          {
            text: 'Bilet/PNR No',
            value: 'BiletPnrNo',
            sortable: false
          },
          {
            text: this.$t('Amount'),
            value: 'Tutar',
            sortable: false
          }
        ],

        headerskapatma: [{
            text: this.$t('Approval'),
            value: 'Onay',
            sortable: false
          },
          {
            text: this.$t('Invoice-Serial'),
            value: 'FaturaSeri',
            sortable: false
          },
          {
            text: this.$t('Invoice-No'),
            value: 'Faturano',
            sortable: false

          },
          {
            text: 'Onay Fat. No',
            value: 'OnayFaturaNo',
            sortable: false
          },
          {
            text: this.$t('Type'),
            value: 'Tip',
            sortable: false
          },
          {
            text: this.$t('Invoice-Date'),
            value: 'FaturaTarih',
            sortable: false
          },
          {
            text: this.$t('Amount'),
            value: 'Tutar',
            sortable: false
          },
          {
            text: this.$t('Payment'),
            value: 'Odeme',
            sortable: false
          },


          {
            text: 'Coper ID',
            value: 'CoperID',
            sortable: false
          },
          {
            text: 'Cs Şirket',
            value: 'CSirket',
            sortable: false
          }
        ],
        itemskapatma: [],
        searchkapatma: null,
        headerskapatmadetay: [{
            text: this.$t('Invoice-Serial'),
            value: 'FaturaSeri'
          },
          {
            text: this.$t('Invoice-No'),
            value: 'Faturano',
          },
          {
            text: this.$t('Description'),
            value: 'Aciklama',

          },
          {
            text: this.$t('Amount'),
            value: 'Tutar'
          }
        ],
        headerskapatmaodeme: [{
            text: this.$t('Invoice-Serial'),
            value: 'FaturaSeri'
          },
          {
            text: this.$t('Invoice-No'),
            value: 'Faturano',
          },
          {
            text: this.$t('Description'),
            value: 'Aciklama',
          },
          {
            text: this.$t('Type'),
            value: 'Tip'
          },
          {
            text: this.$t('Amount'),
            value: 'Tutar'
          },
          {
            text: 'Fat. ID',
            value: 'FaturaID'
          },
          {
            text: this.$t('Ticket-ID'),
            value: 'BiletID'
          },
          {
            text: this.$t('Ticket-AL-ID'),
            value: 'BiletHYID'
          },
          {
            text: this.$t('Payment-Code'),
            value: 'OdemeKod'
          }, {
            text: this.$t('Issue'),
            value: 'SiraNo'
          },
          {
            text: 'Coper ID',
            value: 'CoperID'
          },
          {
            text: this.$t('Coper-Corporation'),
            value: 'CoperSirket'
          },
          {
            text: this.$t('Record-No'),
            value: 'RecordNo'
          }
        ],
        itemskapatmaodeme: [],
        itemskapatmadetay: [],
        searchkapatmadetay: null,
        carihareketview: true,
        faturakapatmaview: false,
        carideneme: null,
        FaturaKapatma: {
          Tip: 0,
          FiltreInfo: false, // false : filtre yok, true : filtre var
          Filtreler: {
            HesapKodu: null,
            FatGoster: null, // H - sorgulama yok , S - Sorgulama var
            Tarih1: null,
            Tarih2: null,
            Tarih3: null,
            BaslangicFatNo: null,
            BitisFatNo: null,
            Fatsec: null, //H - hepsi, B - Bilet, S- Serbest, C- Coper
            TutarMin: 0,
            TutarMax: 0,
            TarihTip: 'T', // V - Vade tarihi, F- Fatura Tarihi
            BiletDb: null,
            SirketKod: null,
          },
          CariInfo: {
            SirketKodu: null,
            Tarih: null,
            CariKodu: null,
            Sirano: null,
            QueryBool: false,
            QueryCmd: false,
          }
        },
        progress: false,
        ilkba: null,
        getControl: false,
        loadingkarsi: false,
        searchkarsi: '',
        statekarsi: [],
        bankapositems: null,
        taksitsayi: [],
        drawer: null,
        baslik: '',
        e1: 0,
        Code: '',
        e2: true,
        rules: {
          required: (value) => !!value || this.$t('Mandatory-Areas'),
          email: (value) => {
            const pattern =
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || this.$t('Wrong-e-mail')
          }
        },
        valid: true,
        loading: false,
        search: '',
        search1: '',
        karsicari: false,
        statecari: [],
        statecari2: [],
        masrafmerkezi: [],
        Referans: [],
        states1: [{
            id: 'A',
            text: this.$t('Credit')
          },
          {
            id: 'B',
            text: this.$t('Debit')
          },
        ],
        doviztipi: [],
        EvrakTipi1: [],
        EvrakTipi2: [],
        items1: [],
OldMovement: {
  Current: null,
  MovementDate: null,
  OrderNumber: null,
},
        Movement: {
          TaxRate: 0,
          Current: '',
          ContraCurrent: 0,
          MovementDate: null,
          MovementDueDate: null,
          DocumentType: '',
          DocumentNumber: '',
          Explanation: '',
          DebitCredit: '',
          Amount: 0,
          ExchangeType: '',
          ExchangeRate: 0,
          ExchangeAmount: 0,
          ContraDocumentType: '',
          ContraDocumentNumber: '',
          ContraExplanation: '',
          ContraExchangeType: '',
          ContraExchangeRate: 0,
          ContraExchangeAmount: 0,
          PaymentCode: '',
          Reference: '',
          ExpenseCenter: null,
          CompanyCode: '',
          ReceiptType: '',
          FirmCardNumber: null,
          PosCode: null,
          InstallmentID: null,
          InstallmentExplanation: null,
          GrossAmount: 0,
          TaxAmount: 0,
          DiscountAmount: 0,
          ContraAccount: null,
          BankCode:null,
          AccountingIntegration: false,
        },
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        deleteInstallmentID:0,
        autocomplete: 'autocomplete',
        tutar: 'tutar',
        etikettutar: 'Tutar',

        doviztutar: 'doviztutar',
        etiketdoviztutar: this.$t('Currency-Amount'),

        kurtutar: 'kurtutar',
        etiketkurtutar: this.$t('Exchange-Rate'),


        karsikurtutar: 'karsikurtutar',
        karsietiketkurtutar: 'Karşı Döviz Kuru',


        karsidoviztutar: 'karsidoviztutar',
        karsietiktutar: 'Karşı Döviz Tutar',
        makbuztipi: [{
            text: this.$t('None'),
            value: '0'
          },
          {
            text: this.$t('Collection-v2'),
            value: '1'
          },
          {
            text: this.$t('Payment-v2'),
            value: '2'
          }
        ],

        dictionary: {
          custom: {
            carikod: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            tarih: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
          }
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    computed: {
},
    mounted() {
        this.simpleModeYukle();

      this.el = this.$refs.fab.$el

      this.$validator.localize('en', this.dictionary)


      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)
      //console.log(this.sayfayetki);
      
      if (this.sayfayetki.Status == true) {




        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.PB=credentials.ParaBirimi;
        var params = {
          CompanyCode: credentials.SirketKodu
        }


        this.$http.post(auth.API_URL + 'api/currency/List', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.doviztipi = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-Döviz'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-Döviz'
            this.snackbar = true
          }
        })





        this.$http.post(auth.API_URL + 'api/doctype/List', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.EvrakTipi1 = response.body
          this.EvrakTipi2 = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-Evrak Tipi'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-Evrak Tipi'
            this.snackbar = true
          }
        })

        this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.masrafmerkezi = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-Masraf Merkezi'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-Masraf Merkezi'
            this.snackbar = true
          }
        })

        // this.$http.post(auth.API_URL + 'api/Reference/List', params, {
        //   headers: {
        //     'Authorization': 'Bearer ' + auth.getAuthHeader()
        //   }
        // }).then((response) => {
        //   this.Referans = response.body
        // }, (response) => {
        //   if (response.status === 0) {
        //     this.text1 = 'Service Unavailable-Referans'
        //     this.snackbar = true
        //   } else {
        //     this.text1 = 'Service Unavailable-Referans'
        //     this.snackbar = true
        //   }
        // })


        this.loadingvmodel = true

        var GetMovement = {
          CompanyCode: credentials.SirketKodu,
          Date: this.$route.query.dt,
          AccountCode: this.$route.query.ac,
          OrderNumber: this.$route.query.on
        };

        if(this.$route.query.dt == null || this.$route.query.dt == ""){
         let data ={
          response: {},
          request:GetMovement,
          api:'CurrentMovement/Get',
          type:1,
          message: this.$t('The-date-field-cannot-be-empty-Please-add-date')
        };
        this.$refs.showMessage.open(data);
        return false;
        }



        this.$http.post(auth.API_URL + 'api/CurrentMovement/Get', GetMovement, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.loadingvmodel = false



          if (response.body.Cari != null) {

            var seciliitems = [{
              unvan1: response.body.Cari.Unvan,
              id: response.body.Cari.Kod
            }]
            this.caricompitems = seciliitems

            this.Movement.Current = response.body.Cari.Kod
            this.Movement.BankCode = response.body.BankaKod

          }


          if (response.body.KarsiHesap != null) {
            this.Movement.ContraAccount = response.body.KarsiHesap
          }


          if (response.body.KarsiCari != null) {

            var seciliitemskarsicari = [{
              autoText: response.body.KarsiCari + '-' + response.body.KarsiCari,
              unvan1: response.body.KarsiCari, //+ '-' + response.body.Cari.Kod,
              id: response.body.KarsiCari
            }]
            this.statecari2 = seciliitemskarsicari
            this.Movement.ContraCurrent = response.body.KarsiCari

          }




          this.Movement.PosCode = response.body.PosKod


          if (response.body.MuhEnt == 'E') {
            this.Movement.AccountingIntegration = true
          } else {
            this.Movement.AccountingIntegration = false
          }

          this.Movement.FirmCardNumber = response.body.FirmaKart

          this.$http.post(auth.API_URL + 'api/BankPos/List', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response1) => {
            this.bankapositems = response1.body
            this.taksitgetir(this.Movement.PosCode)
          }, (response1) => {
            if (response1.status === 0) {
              this.text1 = 'Service Unavailable-bankpos'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable-bankpos'
              this.snackbar = true
            }
          })
          this.deleteInstallmentID = response.body.TaksitRef
          this.Movement.InstallmentID = response.body.TaksitID
          this.Movement.TaxRate = response.body.KdvOran
          this.Movement.GrossAmount = response.body.Brut
          this.Movement.TaxAmount = response.body.Kdv
          this.Movement.DiscountAmount = response.body.Iskonto
          this.Movement.MovementDate = response.body.Tarih
          this.Movement.MovementDueDate = response.body.Vade
          if (response.body.Evrak != null) {

            this.Movement.DocumentType = response.body.Evrak.Evrakkod
          }
          this.Movement.DocumentNumber = response.body.Evrakno
          this.Movement.Explanation = response.body.Aciklama
          this.Movement.DebitCredit = String(response.body.BA)
          this.ilkba = String(response.body.BA)

          this.Movement.Amount = response.body.Tutar
          this.Movement.ReceiptType = String(response.body.MakbuzTip)
          this.Movement.DefinationID = response.body.TanimID
          this.Movement.PaymentCode = response.body.OdemeKod
          this.Movement.ExchangeType = response.body.DovizCinsi
          if (response.body.Masraf != null) {

            this.Movement.ExpenseCenter = response.body.Masraf.Code
          }
         this.Movement.SiraNo = response.body.Sirano

this.OldMovement.Current = response.body.Cari != null ? response.body.Cari.Kod : this.$route.query.ac
this.OldMovement.MovementDate = response.body.Tarih
this.OldMovement.OrderNumber = response.body.Sirano
          if (response.body.Referans != null) {
            this.Movement.Reference = response.body.Referans.Kod
          }
          this.Movement.ExchangeRate = response.body.Kur
          this.Movement.ExchangeAmount = response.body.DovizTutar

          if (response.body.KarsiCari != '') {
            this.Movement.ContraCurrent = response.body.KarsiCari
            this.search1 = this.Movement.ContraCurrent
            this.Movement.ContraDocumentType = response.body.KarsiEvrak
            this.Movement.ContraExplanation = response.body.KarsiAciklama
            this.Movement.ContraExchangeType = response.body.KarsiDovizTip
            this.Movement.ContraExchangeRate = response.body.KarsiKur
            this.Movement.ContraExchangeAmount = response.body.KarsiDovizTutar
            this.karsicari = true

          } else {
            this.karsicari = false
          }


        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.loadingvmodel = false
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.loadingvmodel = false
            this.snackbar = true
          }
        })




      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              var url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              var url = '#/'
              window.open(url, '_self')
            }
          } else {

          }

        });

      }

    },
    methods: {
      simpleModeYukle() {
  var manageload = null;

  try {
    manageload = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));
  } catch (e) {
    manageload = null;
  }

  if (manageload && manageload.UserInfo) {
    this.simpleMode =
      manageload.UserInfo.SimpleMode === true ||
      manageload.UserInfo.SimpleMode === 1 ||
      manageload.UserInfo.SimpleMode === "1" ||
      manageload.UserInfo.SimpleMode === "true";
  }
},
      makbuzIndirmeSecimAc() {
  this.receiptDownloadDialog = true
},

tahsilatMakbuz(format) {
  this.receiptDownloadDialog = false

  var credentials = JSON.parse(window.localStorage.getItem('credentials'))
  var lang = localStorage.getItem('lang')

  this.loadingvmodel = true

  var GetMovement = {
    CompanyCode: credentials.SirketKodu,
    Date: this.$route.query.dt,
    AccountCode: this.$route.query.ac,
    OrderNumber: this.$route.query.on
  }

  if (format == 'PDF') {
    this.$http.post(auth.API_URL + 'api/CurrentMovement/ReceiptPdf', GetMovement, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      },
      responseType: 'blob'
    }).then((response) => {
      this.loadingvmodel = false

      var blob = new Blob([response.body], {
        type: 'application/pdf'
      })

      var link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)

      if (this.Movement.DebitCredit == 'A') {
        link.download = 'CollectionReceipt.pdf'
      } else {
        link.download = 'PaymentReceipt.pdf'
      }

      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      window.URL.revokeObjectURL(link.href)

    }, (response) => {
      this.loadingvmodel = false
      this.text1 = 'Service Unavailable'
      this.snackbar = true
    })

    return
  }

  this.$http.post(auth.API_URL + 'api/CurrentMovement/ReceiptHtml', GetMovement, {
    headers: {
      'Authorization': 'Bearer ' + auth.getAuthHeader()
    }
  }).then((response) => {

    if (lang == 'en') {
      var bodyhtml = response.bodyText

      bodyhtml = bodyhtml.toString().replace('Makbuz Tarihi :', 'Receipt Date :')
      bodyhtml = bodyhtml.toString().replace('<title> TEDİYE MAKBUZU </title>', '<title> Receipt of Payment </title>')
      bodyhtml = bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>TEDİYE MAKBUZU</font>", "<font face = 'Arial' size = '4' color = '#FFFFF0'>Receipt of Payment</font>")
      bodyhtml = bodyhtml.toString().replace('<title> TAHSİLAT MAKBUZU </title>', '<title> Collection Receipt </title>')
      bodyhtml = bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>TAHSİLAT MAKBUZU</font>", "<font face = 'Arial' size = '4' color = '#FFFFF0'>Collection Receipt</font>")
      bodyhtml = bodyhtml.toString().replace('Evrak No', 'Document Number')
      bodyhtml = bodyhtml.toString().replace('Cari Kodu', 'Current Code')
      bodyhtml = bodyhtml.toString().replace('Cari Unvanı', 'Current Title')
      bodyhtml = bodyhtml.toString().replace('Açıklama', 'Explanation')
      bodyhtml = bodyhtml.toString().replace('ödenmiş ve cari hesabınıza BORÇ olarak kaydedilmiştir.', 'has been paid and recorded as DEBIT in your current account.')
      bodyhtml = bodyhtml.toString().replace('tahsil edilmiş ve cari hesabınıza ALACAK olarak kaydedilmiştir.', 'has been collected and recorded as CREDIT in your current account.')
      bodyhtml = bodyhtml.toString().replace('Yalnız', 'Only')
      bodyhtml = bodyhtml.toString().replace("<font face = 'Tahoma' size = '1' color = 'black'>Only", "<font face = 'Tahoma' size = '1' color = 'black' hidden>Only")
      bodyhtml = bodyhtml.toString().replace('TRY', credentials.ParaBirimi)

      response.bodyText = bodyhtml
    }

    this.loadingvmodel = false

    var blob = new Blob([response.bodyText], {
      type: 'application/html'
    })

    var link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = this.$t('Receipt-v2') + '.html'

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    window.URL.revokeObjectURL(link.href)

  }, (response) => {
    this.loadingvmodel = false
    this.text1 = 'Service Unavailable'
    this.snackbar = true
  })
},
      getparabirimi() {
        return helpers.getparabirimi()
      },
      getCurrentParameters(){
        this.$http.post(auth.API_URL + 'api/Parameters/Get', null, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if(response.body.FaturaKapamaAktif == "1"){
            this.getKapaliFatura();
          }else{
            this.FaturaDevam = false;
            this.carihareketGuncelle();
          }
        }, (response) => {
          if (response.status === 0) {
            this.text = 'Service Unavailable'
            this.snackbar = true

          } else {
            this.text = 'Service Unavailable'
            this.snackbar = true

          }
        })
      },
      getKapaliFatura(){
        var prmkapama = {
        OdemeKod: this.Movement.PaymentCode
        }
        this.$http.post(auth.API_URL + 'api/InvoiceMatch/InvoiceMatchPaymentMatchList', prmkapama, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
        }).then((response) => {
        if (response.body.length > 0) {
          this.dialogKapatilanFatura = true
          this.itemskapatilanfatura = response.body
          this.FaturaDevam = true
        } else {
          this.dialogKapatilanFatura = false
          this.FaturaDevam = false
          this.carihareketGuncelle();
        }

        }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }

        })
      },
      GuncelleSor() {
       this.getCurrentParameters();
      },
      handler: function handler(event) {

        event.returnValue = 'You have unfinished changes!';
      },
      otomatikAta() {

        var prmkapama = {
          FaturaInfo: this.itemskapatma,
          SeciliOdemeList: {
            OdemeTarihi: this.kapatma.Tarih,
            OdemeKod: this.kapatma.OdemeKod,
            OdemeTutar: this.kapatma.Odeme,
            KalanTutar: this.kapatma.Kalan,
            OdemeList: this.itemskapatmaodeme
          }
        }

        this.$http.post(auth.API_URL + 'api/InvoiceMatch/InvoiceMatchAutomaticList', prmkapama, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.kapatma.Kalan = response.body.KalanTutar
          this.itemskapatmaodeme = response.body.OdemeList



          this.islemdurum = false

          this.itemskapatmaodeme.forEach(element1 => {
            this.itemskapatma.forEach(element2 => {
              if (element1.RecordNo == element2.RecNo) {

                this.check[element2.RecNo] = true
              }
            });
          });

          this.islemdurum = true


        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }

        })
      },
      EkleKaldir(a, b) {
        if (this.islemdurum == true) {

          if (this.kapatma.Kalan > 0 || b == false) {

            var eklekaldir

            if (b == true) {
              eklekaldir = false
            } else {
              eklekaldir = true
            }

            var prmkapama = {
              EkleKaldir: eklekaldir,
              FaturaInfo: a,
              SeciliOdemeList: {
                OdemeTarihi: this.kapatma.Tarih,
                OdemeKod: this.kapatma.OdemeKod,
                OdemeTutar: this.kapatma.Odeme,
                KalanTutar: this.kapatma.Kalan,
                OdemeList: this.itemskapatmaodeme
              }
            }
            this.$http.post(auth.API_URL + 'api/InvoiceMatch/InvoiceMatchPaymentAddRemoveList', prmkapama, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              if (response.body.ResponseInfo.Status == true) {
                this.kapatma.Kalan = response.body.KalanTutar
                this.itemskapatmaodeme = response.body.OdemeList
              } else {
                this.text1 = this.$t('Add-Remove-process-could-not-completed')
                this.snackbar = true
              }
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              }
            })

          } else {
            this.text1 = this.$t('cannot-add-since-remaining-amount')
            this.snackbar = true
            this.check[a.RecNo] = false
          }

        }

      },
      KapatmaKaydet() {


        var prmkapama = {
          OdemeTarihi: this.kapatma.Tarih,
          OdemeKod: this.kapatma.OdemeKod,
          OdemeTutar: this.kapatma.Odeme,
          KalanTutar: this.kapatma.Kalan,
          OdemeList: this.itemskapatmaodeme
        }

        this.$http.post(auth.API_URL + 'api/InvoiceMatch/InvoiceMatchPaymentSave', prmkapama, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.butongorunum = true
           this.text1 = this.$t(response.body.ResponseMessage)
          this.snackbar = true

          if (response.body.Status == true) {

            this.ekbaslik = ''
            this.carihareketview = true
            this.faturakapatmaview = false
            this.ekbaslik = null
            this.itemskapatmaodeme = []
            this.itemskapatmadetay = []
            this.check = []
            this.itemskapatma = []

            var url = '#/carihareketler/index'
            setTimeout(function () {
              window.open(url, '_self')
            }.bind(this), 4000)




          } else {

          }

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })
      },
      git() {},
      filtrele() {
        this.dialogfiltre = true
        this.FaturaKapatma.Filtreler.Fatsec = 'H'
      },
      kapatmafiltreiptal() {
        this.dialogfiltre = false
        this.FaturaKapatma.Filtreler.FatGoster = null // H - sorgulama yok , S - Sorgulama var
        this.FaturaKapatma.Filtreler.Tarih1 = ''
        this.FaturaKapatma.Filtreler.Tarih2 = ''
        this.FaturaKapatma.FiltreInfo = false
        this.FaturaKapatma.Filtreler.BaslangicFatNo = null
        this.FaturaKapatma.Filtreler.BitisFatNo = null
        this.FaturaKapatma.Filtreler.Fatsec = null //H - hepsi, B - Bilet, S- Serbest, C- Coper
        this.FaturaKapatma.Filtreler.TutarMin = 0
        this.FaturaKapatma.Filtreler.TutarMax = 0
        this.FaturaKapatma.Filtreler.TarihTip = 'T' // V - Vade tarihi, F- Fatura Tarihi
        this.FaturaKapatma.Filtreler.BiletDb = null
        this.FaturaKapatma.Filtreler.SirketKod = null
        this.FaturaKapatma.FiltreInfo = false

        var prmkapama = this.FaturaKapatma

        this.$http.post(auth.API_URL + 'api/InvoiceMatch/InvoiceMatchInvoiceList', prmkapama, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.FaturaInfo.length > 0) {
            this.itemskapatma = response.body.FaturaInfo
            this.dialogfiltre = false

          } else {
            this.text1 =this.$t('No-Records-Found')
            this.snackbar = true
            this.dialogfiltre = false
          }

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }

        })



      },
      filtrekayit() {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.FaturaKapatma.Filtreler.FatGoster = 'S'
        this.FaturaKapatma.Filtreler.SirketKod = credentials.SirketKodu
        this.FaturaKapatma.FiltreInfo = true

        var prmkapama = this.FaturaKapatma

        this.$http.post(auth.API_URL + 'api/InvoiceMatch/InvoiceMatchInvoiceList', prmkapama, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.FaturaInfo.length > 0) {
            this.itemskapatma = response.body.FaturaInfo
            this.dialogfiltre = false

          } else {
            this.text1 =this.$t('No-Records-Found')
            this.snackbar = true
            this.dialogfiltre = false
          }

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }

        })

      },
      KapatilanFaturaGetir() {
        this.FaturaDevam = false

        var prmkapama = {

          OdemeKod: this.Movement.PaymentCode
        }
        this.$http.post(auth.API_URL + 'api/InvoiceMatch/InvoiceMatchPaymentMatchList', prmkapama, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.length > 0) {
            this.dialogKapatilanFatura = true
            this.itemskapatilanfatura = response.body
          } else {
            this.text1 = 'Kayıt bulunamadı.'
            this.snackbar = true
          }

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }

        })
      },
      detaygetir(value) {

        var prmkapama = {
          FaturaID: value.FaturaID,
          BiletID: value.BiletID,
          BiletHYID: value.BiletHYID,
          Tip: value.Tip
        }
        this.$http.post(auth.API_URL + 'api/InvoiceMatch/InvoiceMatchInvoiceDetailList', prmkapama, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.itemskapatmadetay = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }

        })
      },
      brutHesapladiscount(tutar, kdv) {
        var kdvsiztutar = tutar / (kdv / 100 + 1)
        this.Movement.TaxAmount = (kdvsiztutar / 100) * kdv
        this.Movement.GrossAmount = tutar - this.Movement.TaxAmount
      },
      brutHesapla(tutar, kdv) {

        var kdvsiztutar = tutar / (kdv / 100 + 1)
        this.Movement.TaxAmount = (kdvsiztutar / 100) * kdv
        this.Movement.GrossAmount = tutar - this.Movement.TaxAmount

        if (this.Movement.DiscountAmount != 0) {
          this.Movement.GrossAmount = this.Movement.GrossAmount + this.Movement.DiscountAmount
        }
      },
      taksitgetir(v) {

        var tumliste = []

        tumliste = this.bankapositems

        tumliste.forEach(element => {

          if (element.PosKodu == v) {
            this.taksitsayi = []
            this.taksitsayi = element.Taksitler
          }
          //   this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKod = parseInt(this.servistaksitsayi)
        });
      },
      kurgetir(kod) {
        var params1 = {
          Tarih: helpers.getDateNow(),
          DovizKod: kod
        }

        this.$http.post(auth.API_URL + 'api/Definitions/GetWebRate', params1, {
          headers: auth.getAuthCompaniesInfo()
        }).then((response) => {
         if(response.body == 0.0){
          this.Movement.ExchangeRate = 1
          }else{
          this.Movement.ExchangeRate = response.body
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-Kur Hesapla'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-Kur Hesapla'
            this.snackbar = true
          }
        })
      },
      kurgetir1(kod) {
        var params1 = {
          Tarih: helpers.getDateNow(),
          DovizKod: kod
        }

        this.$http.post(auth.API_URL + 'api/Definitions/GetWebRate', params1, {
          headers: auth.getAuthCompaniesInfo()
        }).then((response) => {
          if(response.body == 0.0){
          this.Movement.ContraExchangeRate = 1
          }else{
          this.Movement.ContraExchangeRate = response.body
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-Kur Hesapla'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-Kur Hesapla'
            this.snackbar = true
          }
        })
      },
      carihareketGuncelle: carihareketGuncelle,
      carihareketSil: carihareketSil,
      toDate: toDate,
      toDateformat: toDateformat,
      wait: wait,
      formatMoney: formatMoney,
      karsicariac: karsicariac

    },
    beforeMount: beforeMount,
    components: {
      'parainput': parainput,
      dovizinput,
      tarihcomp,
      doviztutarcomp,
      kredikartcomp,
      yuzdeinput,
      caricomp,
      yetkidialog,
      loadingcomp,
      muhasebekoducomp,
      cariaracomp,
      bankakodu,
      snackbarcomp,
      referansmerkezicomp
    },

    watch: {
      'Movement.ExchangeRate': function (value) {
        if (value != 0) {
          this.Movement.ExchangeAmount = this.Movement.Amount / value;
        }
      },
      'Movement.DocumentType': function (value) {


        if (this.getControl == true) {
          this.EvrakTipi1.forEach(element => {
            if (element.Evrakkod == value) {
              if (element.Cari == '-' || element.Cari == '+') {
              this.kdvGoster = true
            } else {
              this.kdvGoster = false
            }
              if (element.BA.trim() == 'Alacak') {
                this.Movement.DebitCredit = 'A'
              } else if (element.BA.trim() == 'Borç') {
                this.Movement.DebitCredit = 'B'
              }
              if (this.Movement.Explanation == null || this.Movement.Explanation == '') {
                this.Movement.Explanation = element.Title
              }
            }
          });
        } else {
          this.getControl = true
          this.Movement.DebitCredit = String(this.ilkba)
        }

      },
      'Movement.ExchangeAmount': function (value) {
        if (value != 0) {
          this.Movement.Amount = this.Movement.ExchangeRate * value;
        }
      },
      'Movement.Amount': function (value) {
        if (value != 0 && this.Movement.ExchangeRate != 0) {
          this.Movement.ExchangeAmount = value / this.Movement.ExchangeRate;
        }
        this.brutHesapla(value, this.Movement.TaxRate)
      },

      'Movement.TaxRate': function (value) {
        this.brutHesapla(this.Movement.Amount, value)
      },

      'Movement.DiscountAmount': function (value) {

        this.brutHesapladiscount(this.Movement.Amount, this.Movement.TaxRate)

        if (this.Movement.Amount != 0) {
          this.Movement.GrossAmount = this.Movement.GrossAmount + value
        } else {
          this.Movement.GrossAmount = value
        }

      },
    },
    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }
    },
  }



  function formatMoney(n) {
    return parseFloat(n).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1.').replace(/\.(\d+)$/, ',$1');
  }

  function karsicariac() {
    if (this.karsicari === false) {
      this.karsicari = true
      this.Movement.ContraExplanation = this.Movement.Explanation
      this.Movement.ContraDocumentType = this.Movement.DocumentType

    } else {
      this.karsicari = false

    }
  }


  function beforeMount() {


  }

  function toDateformat(dateStr) {


    var parts = dateStr.split("-");
    return (parts[2] + '.' + parts[1] + '.' + parts[0]);
  }

  function toDate(dateStr) {
    var parts = dateStr[0].split("-");
    return (parts[2] + '.' + parts[1] + '.' + parts[0]);
  }

  function carihareketGuncelle() {

    //this.guncellebuton = true

    this.butongorunum = false


    this.dialogKapatilanFatura = false

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (this.$refs.formbiletrapor.validate()) {

      this.loadingvmodel = true
      var currentMovement = this.Movement

      currentMovement['CompanyCode'] = credentials.SirketKodu
      currentMovement['OrderNumber'] = this.Movement.SiraNo
      currentMovement['OldCurrent'] = this.OldMovement.Current
currentMovement['OldMovementDate'] = this.OldMovement.MovementDate
currentMovement['OldOrderNumber'] = this.OldMovement.OrderNumber


      if (this.Movement.Amount > 0) {


        var toplam = helpers.roundNumber(this.Movement.GrossAmount - this.Movement.DiscountAmount + this.Movement.TaxAmount,2)

     if (helpers.roundNumber(this.Movement.Amount,2) >= toplam) {

          this.$http.post(auth.API_URL + 'api/CurrentMovement/Update', currentMovement, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.butongorunum = true

             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true

            if (response.body.Status === true) {

              this.loadingvmodel = false


              this.FaturaKapatma.CariInfo.Tarih = this.Movement.MovementDate
              this.FaturaKapatma.CariInfo.SirketKodu = credentials.SirketKodu
              this.FaturaKapatma.CariInfo.CariKodu = this.Movement.Current
              this.FaturaKapatma.CariInfo.Sirano = response.body.CariResponse.Sirano

              var prmkapama = this.FaturaKapatma

              this.$http.post(auth.API_URL + 'api/InvoiceMatch/InvoiceMatchInvoiceList', prmkapama, {
                headers: {
                  'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
              }).then((response) => {

                this.loadingvmodel = false
                

                var closeCariIDS = JSON.parse(localStorage.getItem('closeCariIDS'));
                if(typeof closeCariIDS !== 'undefined' && closeCariIDS != null){
                  closeCariIDS.push(this.Movement.SiraNo);
                  localStorage.setItem('closeCariIDS', JSON.stringify(closeCariIDS));
                }else{
                  var closedArray = new Array();
                  closedArray.push(this.Movement.SiraNo);
                  localStorage.setItem('closeCariIDS', JSON.stringify(closedArray));
                }
                
                if (response.body.ResponseInfo) {
                  this.ekbaslik = '(Fatura Kapatma)'
                  this.itemskapatma = response.body.FaturaInfo
                  this.kapatma.Tarih = this.Movement.MovementDate
                  this.kapatma.Odeme = this.Movement.Amount
                  this.kapatma.Kalan = this.Movement.Amount
                  this.kapatma.OdemeKod = response.body.CariHareketInfo.OdemeKod
                  this.Title.Kod = response.body.CariHareketInfo.Cari.Kod
                  this.Title.Unvan = response.body.CariHareketInfo.Cari.Unvan
                  this.Title.EvrakTip = response.body.CariHareketInfo.Evrak.Evrakkod
                  this.Title.EvrakKod = response.body.CariHareketInfo.Evrakno
                  this.carihareketview = false
                  this.faturakapatmaview = true
                } else {
                  this.butongorunum = true
                  this.ekbaslik = ''
                  this.carihareketview = true
                  this.faturakapatmaview = false
                  this.ekbaslik = null


                  var url = '#/carihareketler/index'
                  setTimeout(function () {
                    window.open(url, '_self')
                  }.bind(this), 4000)



                }



              }, (response) => {
                if (response.status === 0) {
                  this.text1 = 'Service Unavailable'
                  this.snackbar = true
                  this.butongorunum = true

                  this.loadingvmodel = false
                } else {
                  this.text1 = 'Service Unavailable'
                  this.snackbar = true
                  this.butongorunum = true

                  this.loadingvmodel = false
                }

              })


            } else {
               this.text1 = this.$t(response.body.ResponseMessage)
              this.snackbar = true
              this.butongorunum = true
            }
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.butongorunum = true
            }
          })

        } else {
          this.butongorunum = true

          this.text1 = this.$t('Gross-Discount-VAT-cannot-exceed-amount')
          this.snackbar = true
        }

      } else {
        this.text1 = this.$t('Please-enter-amount')
        this.snackbar = true
        this.butongorunum = true

      }
    } else {
      this.butongorunum = true

    }
  }

  function wait(ms) {
    var d = new Date();
    var d2 = null;
    do {
      d2 = new Date();
    }
    while (d2 - d < ms);
  }

  function carihareketSil() {
    this.loadingvmodel = true;
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));



      var currentMovement = {
        AccountCode: this.Movement.Current,
        CompanyCode: credentials.SirketKodu,
        Date: this.Movement.MovementDate,
        OrderNumber: this.Movement.SiraNo,
        DefinationID: this.Movement.DefinationID,
        InstallmentID: this.deleteInstallmentID, 
        PaymentCode: this.Movement.PaymentCode
      }

      this.$http.post(auth.API_URL + 'api/CurrentMovement/Delete', currentMovement, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.Status === true) {
           this.text1 = this.$t(response.body.ResponseMessage)
          this.snackbar = true
          wait(2000);
          var url = '#/carihareketler/index'
          window.open(url, '_target')
          this.loadingvmodel = false;


        } else {
           this.text1 = this.$t(response.body.ResponseMessage)
          this.snackbar = true
                    this.loadingvmodel = false;

        }
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.loadingvmodel = false;
        }
      })
  }
</script>

<style>
</style>